/** The options read "2x monthly rent"; on a page the multiplication sign is the typeset one */
export function rentMultipleLabel(value: string): string {
  return value.replace(/^(\d+(?:\.\d+)?)x\b/, '$1×');
}
